import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
@Component({
    selector: 'box',
    templateUrl: './box.html',
    styleUrls: ['./box.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoxComponent {
    /**
     * if selected
     */
    @Input()
    @HostBinding('class.is-selected')
    selected: boolean = false;
    /**
     * if red styling applies
     */
    @Input()
    @HostBinding('class.is-warning')
    warning: boolean = false;
    @Input()
    @HostBinding('class.is-disabled')
    disabled: boolean = false;
}
